import type { StreamItem } from "../types/meeting.types";

type NamedStream = Pick<StreamItem, "name" | "role" | "label">;

const ADVOCATE_SIDE_PREFIX: Record<string, string> = {
  petitioner: "Petitioner Adv.",
  respondent: "Respondent Adv.",
};

/**
 * Courtroom display name for a participant tile / recording overlay:
 *  - Judge     → "Hon'ble Justice <name>"
 *  - Advocate  → "Petitioner Adv. <name>" / "Respondent Adv. <name>" ("Adv. <name>" if side unknown)
 *  - others    → name, falling back to role
 */
export const getParticipantDisplayName = ({
  name,
  role,
  label,
}: NamedStream): string => {
  const baseName = (name || "").trim();

  if (role === "Judge") {
    if (/^hon'?ble\b/i.test(baseName)) return baseName;
    return baseName ? `Hon'ble Justice ${baseName}` : "Hon'ble Justice";
  }

  if (role === "Advocate") {
    const prefix =
      ADVOCATE_SIDE_PREFIX[(label || "").toLowerCase()] || "Adv.";
    return baseName ? `${prefix} ${baseName}` : prefix;
  }

  return baseName || role || "Participant";
};
